import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useHeaderVisibility = () => {
    const [isHeaderVisible, setIsHeaderVisible] = useState(false);
    const location = useLocation();
    const isHomePage = location.pathname === '/';

    useEffect(() => {
        if (!isHomePage) {
            // Always show header on non-home pages
            setIsHeaderVisible(true);
            return;
        }

        // On home page: show header when body.scrollTop > 777 * number of poster rows
        const getPosterRows = () => {
            // Find the element with data-poster-rows attribute
            const posterContainer = document.querySelector('[data-poster-rows]');
            if (posterContainer) {
                const rows = parseInt(posterContainer.getAttribute('data-poster-rows'), 10);
                return isNaN(rows) ? 2 : rows + 1; // Default to 2 if not found or invalid
            }
            return 2; // Default to 2 if element not found
        };

        const handleScroll = () => {
            const bodyScrollTop = document.body.scrollTop || 0;
            const posterRows = getPosterRows();
            const scrollThreshold = 777 * posterRows;
            const shouldShow = bodyScrollTop > scrollThreshold;
            setIsHeaderVisible(shouldShow);
        };

        // Check initial scroll position after a brief delay to ensure DOM is ready
        const checkInitialScroll = () => {
            handleScroll();
        };

        // Check immediately and also after a short delay to catch any layout shifts
        checkInitialScroll();
        const timeoutId = setTimeout(checkInitialScroll, 100);
        const timeoutId2 = setTimeout(checkInitialScroll, 500);

        // Listen to scroll events on multiple targets to ensure we catch all scroll events
        window.addEventListener('scroll', handleScroll, { passive: true });
        document.addEventListener('scroll', handleScroll, { passive: true });
        document.documentElement.addEventListener('scroll', handleScroll, { passive: true });
        document.body.addEventListener('scroll', handleScroll, { passive: true });

        // Also listen for resize events in case layout changes affect scroll position
        window.addEventListener('resize', handleScroll, { passive: true });

        return () => {
            clearTimeout(timeoutId);
            clearTimeout(timeoutId2);
            window.removeEventListener('scroll', handleScroll);
            document.removeEventListener('scroll', handleScroll);
            document.documentElement.removeEventListener('scroll', handleScroll);
            document.body.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
        };
    }, [isHomePage, location.pathname]);

    return isHeaderVisible;
};

export default useHeaderVisibility;
